export const AiDiamonds = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 24 24"
      className="inline-block w-6"
    >
      <path
        fill="currentColor"
        d="M6.5 1a1 1 0 0 1 1 1c0 1.44.32 2.25.785 2.715C8.751 5.18 9.56 5.5 11 5.5a1 1 0 1 1 0 2c-1.44 0-2.25.32-2.715.785C7.82 8.751 7.5 9.56 7.5 11a1 1 0 1 1-2 0c0-1.44-.32-2.25-.785-2.715C4.249 7.82 3.44 7.5 2 7.5a1 1 0 0 1 0-2c1.44 0 2.25-.32 2.715-.785C5.18 4.249 5.5 3.44 5.5 2a1 1 0 0 1 1-1m0 4.7a4 4 0 0 1-.8.8 4 4 0 0 1 .8.8 4 4 0 0 1 .8-.8 4 4 0 0 1-.8-.8M15 7a1 1 0 0 1 1 1c0 2.309.51 3.742 1.384 4.616S19.692 14 22 14a1 1 0 1 1 0 2c-2.308 0-3.742.51-4.616 1.384S16 19.692 16 22a1 1 0 1 1-2 0c0-2.308-.51-3.742-1.384-4.616S10.309 16 8 16a1 1 0 1 1 0-2c2.309 0 3.742-.51 4.616-1.384S14 10.309 14 8a1 1 0 0 1 1-1m0 5.733a5.7 5.7 0 0 1-.97 1.297 5.7 5.7 0 0 1-1.297.97q.719.394 1.297.97.576.578.97 1.297.394-.719.97-1.297a5.7 5.7 0 0 1 1.297-.97 5.7 5.7 0 0 1-1.297-.97 5.7 5.7 0 0 1-.97-1.297"
        fillRule="evenodd"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default AiDiamonds;
